import queryString from "query-string";
import { SCHEDULES } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";
import { getEntity } from "../../actions/actionUtils.js";

export const getSchedule = (id, options) => {
  return getEntity(SCHEDULES, id, options);
};

export const getSchedules = searchParams => {
  return {
    type: SCHEDULES.GET,
    payload: {
      endpoint: ENDPOINTS.SCHEDULES,
      ...queryString.parse(searchParams)
    }
  };
};

export const createSchedule = data => {
  return {
    type: SCHEDULES.POST,
    payload: {
      ...data,
      endpoint: ENDPOINTS.SCHEDULES
    }
  };
};

export const updateSchedule = (id, data) => {
  return {
    type: SCHEDULES.PUT,
    payload: {
      ...data,
      ["@id"]: id
    }
  };
};
